import { NgIf } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgxIntlTelInputModule, SearchCountryField, CountryISO, PhoneNumberFormat } from 'ngx-intl-tel-input';
import { IMaskModule } from 'angular-imask';
import { CommonConfigService } from '../../../utils/common-config';
import { environment } from '../../../../environments/environment';

@Component({
    selector: 'app-contact-us-form',
    imports: [ReactiveFormsModule, NgIf, NgxIntlTelInputModule, IMaskModule],
    standalone: true,
    templateUrl: './contact-us-form.component.html',
    styleUrls: ['./contact-us-form.component.less'],
})
export class ContactUsFormComponent {
    @Output() submitSuccess = new EventEmitter<void>();
    contactForm: FormGroup;
    CountryISO = CountryISO;
    PhoneNumberFormat = PhoneNumberFormat;
    preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
    SearchCountryField = SearchCountryField;
    nameMask;

    constructor(
        private formBuilder: FormBuilder,
        private commonConfigService: CommonConfigService,
        private http: HttpClient
    ) {
        this.contactForm = this.formBuilder.group({
            name: ['', Validators.required],
            companyName: ['', Validators.required],
            email: ['', [Validators.required, Validators.email]],
            phone: [
                {
                    number: '',
                    countryCode: '',
                    dialCode: '',
                },
            ],
            note: ['', Validators.required],
        });
        this.nameMask = this.commonConfigService.getNameMaskConfig();
    }

    isInvalid(controlName: string): boolean {
        const control = this.contactForm.get(controlName);
        return Boolean(control && control.invalid && (control.dirty || control.touched));
    }

    onSubmit() {
        if (this.contactForm.invalid) {
            this.contactForm.markAllAsTouched();
            return;
        }
        const params = this.contactForm.value;
        params.phone = params.phone ? `${params.phone.dialCode} ${params.phone.number}` : null;
        this.trimObjectValues(params);
        this.http.post(`${environment.apiUrl}/ContactUs/submit`, params).subscribe({
            next: (res: any) => {
                this.contactForm.reset();
                this.submitSuccess.emit();
            },
        });
    }

    trimObjectValues(obj: any): void {
        Object.keys(obj).forEach((key) => {
            if (typeof obj[key] === 'string') {
                obj[key] = obj[key].trim();
            }
        });
    }

    formatPhoneNumber() {
        const phoneControl = this.contactForm.controls['phone'];
        phoneControl.setValue(phoneControl.value);
    }
}
